export const SHIPPING_PREFERENCE_OWN = 'own_shipping';
export const SHIPPING_PREFERENCE_PLATFORM = 'platform_shipping';

export const SHIPPING_PREFERENCES = [SHIPPING_PREFERENCE_OWN, SHIPPING_PREFERENCE_PLATFORM];

export const DEFAULT_DIMENSION_UNIT = 'in';
export const DEFAULT_WEIGHT_UNIT = 'lb';

export const DIMENSION_UNITS = ['in', 'cm'];
export const WEIGHT_UNITS = ['lb', 'oz', 'kg', 'g'];

const hasValue = value => value != null && `${value}`.trim() !== '';
const hasPositiveNumber = value => Number(value) > 0;

export const getShippingPreference = publicData => {
  const preference = publicData?.shippingPreference;
  return SHIPPING_PREFERENCES.includes(preference) ? preference : SHIPPING_PREFERENCE_OWN;
};

export const isPlatformShipping = publicData =>
  getShippingPreference(publicData) === SHIPPING_PREFERENCE_PLATFORM;

export const isOwnShipping = publicData =>
  getShippingPreference(publicData) === SHIPPING_PREFERENCE_OWN;

export const isPlatformShippingListing = listing =>
  listing?.attributes?.publicData?.shippingEnabled &&
  isPlatformShipping(listing?.attributes?.publicData);

export const isOwnShippingListing = listing =>
  listing?.attributes?.publicData?.shippingEnabled &&
  isOwnShipping(listing?.attributes?.publicData);

export const hasValidOriginAddress = origin => {
  return !!(
    origin &&
    hasValue(origin.name) &&
    hasValue(origin.street1) &&
    hasValue(origin.city) &&
    hasValue(origin.state) &&
    hasValue(origin.postalCode) &&
    hasValue(origin.country) &&
    hasValue(origin.phone || origin.email)
  );
};

export const hasValidPackageDetails = packageDetails => {
  return !!(
    packageDetails &&
    hasPositiveNumber(packageDetails.length) &&
    hasPositiveNumber(packageDetails.width) &&
    hasPositiveNumber(packageDetails.height) &&
    hasValue(packageDetails.distanceUnit || packageDetails.dimensionUnit) &&
    hasPositiveNumber(packageDetails.weight) &&
    hasValue(packageDetails.massUnit || packageDetails.weightUnit)
  );
};

export const hasValidPlatformShippingDetails = privateData => {
  return (
    hasValidOriginAddress(privateData?.shippingOrigin) &&
    hasValidPackageDetails(privateData?.shippingPackage)
  );
};

export const hasValidOwnShippingFee = publicData => {
  return publicData?.shippingPriceInSubunitsOneItem != null;
};

export const hasValidOwnShippingPreferences = shippingPreferences => {
  return shippingPreferences?.defaultShippingFeeInSubunits != null;
};

export const getUserShippingPreferences = currentUser => {
  return currentUser?.attributes?.profile?.protectedData?.shippingPreferences || {};
};

const getShippingPreferenceFromPreferences = shippingPreferences => {
  const preference = shippingPreferences?.shippingPreference;

  if (SHIPPING_PREFERENCES.includes(preference)) {
    return preference;
  }
  if (hasValidOwnShippingPreferences(shippingPreferences)) {
    return SHIPPING_PREFERENCE_OWN;
  }
  if (
    hasValidOriginAddress(shippingPreferences?.defaultOrigin) &&
    hasValidPackageDetails(shippingPreferences?.defaultPackage)
  ) {
    return SHIPPING_PREFERENCE_PLATFORM;
  }
  return null;
};

export const hasShippingPreferences = currentUser => {
  const shippingPreferences = getUserShippingPreferences(currentUser);
  const shippingPreference = getShippingPreferenceFromPreferences(shippingPreferences);

  return shippingPreference === SHIPPING_PREFERENCE_OWN
    ? hasValidOwnShippingPreferences(shippingPreferences)
    : shippingPreference === SHIPPING_PREFERENCE_PLATFORM
    ? hasValidOriginAddress(shippingPreferences.defaultOrigin) &&
      hasValidPackageDetails(shippingPreferences.defaultPackage)
    : false;
};
